// The assets are handled by Rails on production environment.
if (process.env.NODE_ENV === 'development') {
  require('@asset/stylesheets/application.dev');
}

// Now the files are loaded, start the router.
// NOTE: Order of files is important.
import './core-bundle/init';

import './init/trackjs';
import './init/cookie';
import './init/launch-darkly';
import './init/analytics';
import './init/snowplow/';
import './init/browser';
import './init/locale';
import './init/konami';
import './init/recaptcha';
import './init/font-loader';
import './init/routing';
import './init/free-users';
import './init/plus-users';
import './init/compatibility-version';
import './init/subscriptions';

// We can remove this from the global scope now, all
// data has been processed by the initializers
window['__session__'] = undefined;
